import CartRedesignDescriptor from './cartscreen-redesign-descriptor';
import CartCanteenDescriptor from './cartscreen-canteen-descriptor';
import CartCompanyKitchenDescriptor from './cartscreen-companykitchen-descriptor';
import CartRefiveDescriptor from './cartscreen-refive-descriptor';

import Settings from 'src/Settings';
import {StyleProp, TextStyle} from 'react-native';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: CartRedesignDescriptor,
  [BuildTypeEnum.canteen]: CartCanteenDescriptor,
  [BuildTypeEnum.default]: CartRedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CartCompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: CartRefiveDescriptor,
};

export interface ProductCategorySearchDescriberData {
  styles?: {[index: string]: {[index: string]: number | string}};
  category?: string;
}
export interface ScanDiscountCodeStylesDescriptor {
  descriptionText: StyleProp<TextStyle>;
}
export interface ManualEntryButtonProps {
  handleManualEntry?: () => void;
}
export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
